module.exports = __webpack_public_path__ + "static/media/Ecobank.ef77b8b7.png";